import script from "./RenovationWorkView.vue?vue&type=script&setup=true&lang=js"
export * from "./RenovationWorkView.vue?vue&type=script&setup=true&lang=js"

import "./RenovationWorkView.vue?vue&type=style&index=0&id=1eec26dd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1eec26dd"]])

export default __exports__